import PropTypes from 'prop-types'

import { Grid, TextField } from '@material-ui/core'

import { Controller } from 'react-hook-form'

import { BasePhoneInput, Card, RadioTypeCompany } from 'components'

import constants from 'constants/index'
import helpers from 'helpers'
import { useEffect } from 'react'

const CompanyData = ({
  control,
  errors,
  watch,
  setValue,
  preRegistration,
  isEdit,
  companySupplierIsJuridic,
  isSupplier,
  companySupplier,
}) => {
  const kind = watch('kind')

  useEffect(() => {
    if (kind !== preRegistration?.kind && isEdit)
      return setValue('document', '')

    const document = isSupplier
      ? companySupplier?.document
      : helpers.formatters.cnpjOrCpfOrInternationMask(
          preRegistration?.document,
          kind === constants.companies.KIND_INTERNATIONAL,
        )

    setValue('document', document)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [kind])

  const isPersonal =
    kind === constants.companies.KIND_PERSONAL && !companySupplierIsJuridic

  return (
    <Card title="Preencha os dados da empresa">
      <Grid container spacing={2}>
        <RadioTypeCompany
          control={control}
          watch={watch}
          disabled={isSupplier}
        />
        <Grid item xs={isPersonal ? 12 : 6}>
          <Controller
            control={control}
            name="fantasyName"
            mode="onChange"
            as={
              <TextField
                fullWidth
                error={!!errors.fantasyName}
                helperText={errors?.fantasyName?.message}
                label="Nome fantasia da empresa"
                inputProps={{ maxLength: 60 }}
              />
            }
          />
        </Grid>
        {!isPersonal && (
          <Grid item xs={6}>
            <Controller
              control={control}
              name="name"
              mode="onChange"
              as={
                <TextField
                  fullWidth
                  error={!!errors.name}
                  helperText={errors?.name?.message}
                  label="Razão social da empresa"
                  inputProps={{ maxLength: 60 }}
                />
              }
            />
          </Grid>
        )}
        <Grid item xs={6}>
          <Controller
            control={control}
            name="document"
            mode="onChange"
            onChange={([event]) =>
              helpers.formatters.cnpjOrCpfOrInternationMask(
                event.target.value,
                kind === constants.companies.KIND_INTERNATIONAL,
              )
            }
            as={
              <TextField
                fullWidth
                error={!!errors.document}
                helperText={errors?.document?.message}
                disabled={isSupplier}
                label={constants.companies.LABEL_TYPE_DOCUMENT[kind]}
              />
            }
          />
        </Grid>
        <Grid item xs={6}>
          <Controller
            as={
              <BasePhoneInput
                label="Telefone financeiro"
                error={!!errors.phone}
                helperText={errors?.phone?.message}
                fullWidth
              />
            }
            control={control}
            name="phone"
            mode="onChange"
          />
        </Grid>
        <Grid item xs={6}>
          <Controller
            as={
              <TextField
                fullWidth
                error={!!errors.email}
                helperText={errors?.email?.message}
                label="E-mail financeiro"
              />
            }
            control={control}
            name="email"
            mode="onBlur"
          />
        </Grid>
        <Grid item xs={6}>
          <Controller
            as={
              <TextField
                fullWidth
                error={!!errors.contactName}
                helperText={errors?.contactName?.message}
                label="Nome do responsável financeiro"
              />
            }
            control={control}
            name="contactName"
            mode="onBlur"
          />
        </Grid>
      </Grid>
    </Card>
  )
}

CompanyData.propTypes = {
  control: PropTypes.object.isRequired,
  watch: PropTypes.func,
  errors: PropTypes.object.isRequired,
  isTrialCompany: PropTypes.bool.isRequired,
  setValue: PropTypes.func.isRequired,
  preRegistration: PropTypes.object,
  isEdit: PropTypes.bool,
}

export default CompanyData
